import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

const settings = {
    selectors: {
        closeButton: '.modal__close-button',
        modalContainer: '.modal__container',
    },

    classNames: {
        closing: 'modal--closing',
    },
};

export default class Modal {
    constructor(
        template,
        allowDefaultCloseActions = true,
    ) {
        // Create element from template and append to the DOM
        this.container = document.createElement('div');
        this.container.innerHTML = template;
        this.container = this.container.firstChild;
        this.modalContainer = this.container
            .querySelector(settings.selectors.modalContainer);

        if (allowDefaultCloseActions) {
            // Setup backdrop & close button
            this.container.addEventListener('click', (event) => {
                // Stop here if the click occurred within our modal,
                // as opposed to the underlying backdrop
                if (event.target == this.modalContainer) {
                    return;
                } else if (
                    event.target.closest(settings.selectors.modalContainer)
                ) {
                    return;
                }

                // Close the modal
                this.close();
            });

            const button = this.container
                .querySelector(settings.selectors.closeButton);
            if (button) {
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.close();
                });
            }
        }
    }

    show(
        immediate = false,
        showAsDialogModal = true,
    ) {
        // Add container to the DOM
        document.body.appendChild(this.container);

        // Disable scrolling
        disableBodyScroll(this.container);

        // Show the modal
        if (showAsDialogModal !== false) {
            this.container.showModal();
        } else {
            this.container.show();
        }
    }

    close(immediate = false) {
        // Enable scrolling
        enableBodyScroll(this.container);

        const closeCallback = () => {
            // Close the modal
            this.container.close();

            // Remove container from the DOM
            this.container.remove();
            this.container.removeEventListener('animationend', closeCallback);
            this.container.classList.remove(settings.classNames.closing);
        };

        if (immediate === true) {
            closeCallback();
        } else {
            this.container.addEventListener('animationend', closeCallback);

            // Close the modal
            this.container.classList.add(settings.classNames.closing);
        }
    }
}
